export default __webpack_public_path__ + "static/media/logo.fbdc638d.png";